import request from "@/utils/request";



/* 场馆图片列表 */
export function getNewYearCoupon(query) {
  return request({
    url: '/?m=Rabbit&a=coupon',
    method: 'get',
    params: query
  })
}
